enum controller {
    'fast_backward' = 'Fast backward',
    'fast_forward' = 'Fast forward',
    'pause' = 'Pause',
    'play' = 'Play',
    'step_backward' = 'Step backward',
    'step_forward' = 'Step forward',
    'stop' = 'Stop',
}

export default controller;
